export const CREATOR_OVERVIEW_SINGLE_CREATOR = [
  { h: 1, type: 'HEADER', w: 6, x: 0, y: 0, meta: { name: 'Creators Performance - Instagram' } },
  {
    h: 4,
    type: 'CREATOR_LINE_GRAPH',
    w: 3,
    x: 0,
    y: 1,
    meta: {
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_UGC'],
      metrics: ['UGC_EMV'],
    },
  },
  {
    h: 4,
    type: 'CREATOR_LINE_GRAPH',
    w: 3,
    x: 3,
    y: 1,
    meta: {
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_UGC'],
      metrics: ['UGC_ENGAGEMENTS_PUBLIC'],
    },
  },
  {
    h: 2,
    type: 'CREATOR_TOTAL_METRIC',
    w: 1,
    x: 0,
    y: 5,
    meta: {
      aggregate_by: 'TOTAL',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_UGC'],
      metrics: ['UGC_EMV'],
    },
  },
  {
    h: 2,
    type: 'CREATOR_TOTAL_METRIC',
    w: 1,
    x: 1,
    y: 5,
    meta: {
      aggregate_by: 'TOTAL',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_UGC'],
      metrics: ['UGC_COMMENTS'],
    },
  },
  {
    h: 2,
    type: 'CREATOR_TOTAL_METRIC',
    w: 1,
    x: 2,
    y: 5,
    meta: {
      aggregate_by: 'TOTAL',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_UGC'],
      metrics: ['UGC_AVG_ENGAGEMENT_RATE_FOLLOWERS'],
    },
  },
  {
    h: 2,
    type: 'CREATOR_TOTAL_METRIC',
    w: 1,
    x: 3,
    y: 5,
    meta: {
      aggregate_by: 'TOTAL',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_UGC'],
      metrics: ['UGC_LIKES'],
    },
  },
  {
    h: 2,
    type: 'CREATOR_TOTAL_METRIC',
    w: 1,
    x: 4,
    y: 5,
    meta: {
      aggregate_by: 'BRAND',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_UGC'],
      metrics: ['UGC_ENGAGEMENTS_PUBLIC'],
    },
  },
  {
    h: 4,
    type: 'CREATOR_CONTENT',
    w: 6,
    x: 0,
    y: 7,
    meta: {
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_UGC'],
      metrics: ['UGC_EMV'],
      sort_order: 'DESC',
    },
  },
  {
    h: 4,
    type: 'CREATOR_CONTENT',
    w: 6,
    x: 0,
    y: 11,
    meta: {
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_UGC'],
      metrics: ['UGC_EMV'],
      sort_order: 'ASC',
    },
  },
  {
    h: 1,
    type: 'HEADER',
    w: 6,
    x: 0,
    y: 15,
    meta: { name: 'Creators Performance - Instagram Stories (Connected Creators Only)' },
  },
  {
    h: 4,
    type: 'CREATOR_LINE_GRAPH',
    w: 3,
    x: 0,
    y: 16,
    meta: {
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_STORIES_UGC'],
      metrics: ['UGC_EMV'],
    },
  },
  {
    h: 4,
    type: 'CREATOR_LINE_GRAPH',
    w: 3,
    x: 3,
    y: 16,
    meta: {
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_STORIES_UGC'],
      metrics: ['AVG_REACH'],
    },
  },
  {
    h: 2,
    type: 'CREATOR_TOTAL_METRIC',
    w: 1,
    x: 0,
    y: 20,
    meta: {
      aggregate_by: 'TOTAL',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_STORIES_UGC'],
      metrics: ['UGC_EMV'],
    },
  },
  {
    h: 2,
    type: 'CREATOR_TOTAL_METRIC',
    w: 1,
    x: 1,
    y: 20,
    meta: {
      aggregate_by: 'TOTAL',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_STORIES_UGC'],
      metrics: ['AVG_COMPLETION_RATE'],
    },
  },
  {
    h: 2,
    type: 'CREATOR_TOTAL_METRIC',
    w: 1,
    x: 2,
    y: 20,
    meta: {
      aggregate_by: 'TOTAL',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_STORIES_UGC'],
      metrics: ['VIEWS'],
    },
  },
  {
    h: 2,
    type: 'CREATOR_TOTAL_METRIC',
    w: 1,
    x: 3,
    y: 20,
    meta: {
      aggregate_by: 'TOTAL',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_STORIES_UGC'],
      metrics: ['AVG_REACH'],
    },
  },
  {
    h: 4,
    type: 'CREATOR_CONTENT',
    w: 6,
    x: 0,
    y: 22,
    meta: {
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_STORIES_UGC'],
      metrics: ['REACH'],
      sort_order: 'DESC',
    },
  },
  {
    h: 4,
    type: 'CREATOR_CONTENT',
    w: 6,
    x: 0,
    y: 26,
    meta: {
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['INSTAGRAM_STORIES_UGC'],
      metrics: ['EMV'],
      sort_order: 'DESC',
    },
  },
  { h: 1, type: 'HEADER', w: 6, x: 0, y: 30, meta: { name: 'UGC Performance - TikTok' } },
  {
    h: 4,
    type: 'CREATOR_LINE_GRAPH',
    w: 3,
    x: 0,
    y: 31,
    meta: {
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['TIKTOK_UGC'],
      metrics: ['UGC_EMV'],
    },
  },
  {
    h: 4,
    type: 'CREATOR_LINE_GRAPH',
    w: 3,
    x: 3,
    y: 31,
    meta: {
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['TIKTOK_UGC'],
      metrics: ['VIDEO_VIEWS'],
    },
  },
  {
    h: 2,
    type: 'CREATOR_TOTAL_METRIC',
    w: 1,
    x: 0,
    y: 35,
    meta: {
      aggregate_by: 'TOTAL',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['TIKTOK_UGC'],
      metrics: ['UGC_EMV'],
    },
  },
  {
    h: 2,
    type: 'CREATOR_TOTAL_METRIC',
    w: 1,
    x: 1,
    y: 35,
    meta: {
      aggregate_by: 'TOTAL',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['TIKTOK_UGC'],
      metrics: ['COMMENTS'],
    },
  },
  {
    h: 2,
    type: 'CREATOR_TOTAL_METRIC',
    w: 1,
    x: 2,
    y: 35,
    meta: {
      aggregate_by: 'TOTAL',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['TIKTOK_UGC'],
      metrics: ['SHARES'],
    },
  },
  {
    h: 2,
    type: 'CREATOR_TOTAL_METRIC',
    w: 1,
    x: 3,
    y: 35,
    meta: {
      aggregate_by: 'TOTAL',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['TIKTOK_UGC'],
      metrics: ['UGC_LIKES'],
    },
  },
  {
    h: 2,
    type: 'CREATOR_TOTAL_METRIC',
    w: 1,
    x: 4,
    y: 35,
    meta: {
      aggregate_by: 'TOTAL',
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['TIKTOK_UGC'],
      metrics: ['VIDEO_VIEWS'],
    },
  },
  {
    h: 4,
    type: 'CREATOR_CONTENT',
    w: 6,
    x: 0,
    y: 37,
    meta: {
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['TIKTOK_UGC'],
      metrics: ['UGC_EMV'],
      sort_order: 'DESC',
    },
  },
  {
    h: 4,
    type: 'CREATOR_CONTENT',
    w: 6,
    x: 0,
    y: 41,
    meta: {
      brand_ids: ['brand_ids'],
      creator_ids: ['creator_ids'],
      channels: ['TIKTOK_UGC'],
      metrics: ['UGC_EMV'],
      sort_order: 'ASC',
    },
  },
];
